import { getFallbackValueIfNull } from 'owa-options-core';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import getStore from '../data/store/store';
export default function isConfettiEnabled() {
    return getFallbackValueIfNull(getStore().isEnabled, getOptionsForFeature(OwsOptionsFeatureType.Confetti).confettiEnabled);
}
//# sourceMappingURL=isConfettiEnabled.js.map